import "./style/index.css?version=1.0.1";
import App from "./components/app";
export default App;
// Check
let a = "Init";
console.log(a);
